export const TOGGLE_POPUP = 'TOGGLE_POPUP';
export default TOGGLE_POPUP;
